import React from 'react'
import Banner from '../Banner/Banner'
import CoinsTable from './CoinsTable'

const HomePage = () => {
  return (
    <div>
      <Banner />
    <CoinsTable />
    </div>
  )
}

export default HomePage